// E2E-aware hooks: real, prod-facing code that integrates with the
// `__SOLOMON_E2E__` harness. Kept separate from the plain wallet hooks.
export { useTransactionSigner } from "./useTransactionSigner";
